/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {CreateByNameRequest} from "../model/create-by-name-request";
import {DeleteBatchMarkersetRequest} from "../model/delete-batch-markerset-request";
import {DeleteMarkersetRequest} from "../model/delete-markerset-request";
import {DuplicateMarkersetRequest} from "../model/duplicate-markerset-request";
import {ListData} from "../model/list-data";
import {Markerset} from "../model/markerset";
import {SuccessCreateResponse} from "../model/success-create-response";
import {SuccessResponse} from "../model/success-response";

@Injectable({
    providedIn: "root",
})
export class SimMarkersetService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public createMarkerset(markersetRequest: CreateByNameRequest) {
        return super.post<SuccessCreateResponse>(`/api/Markerset/CreateMarkerset`, markersetRequest);
    }

    public deleteBatchMarkerset(request: DeleteBatchMarkersetRequest) {
        return super.post<SuccessResponse>(`/api/Markerset/DeleteBatchMarkerset`, request);
    }

    public deleteMarkerset(markersetRequest: DeleteMarkersetRequest) {
        return super.post<SuccessResponse>(`/api/Markerset/DeleteMarkerset`, markersetRequest);
    }

    public downloadMarkerset_Url(markersetId: string) {
        return super.getUrl(`/api/Markerset/DownloadMarkerset`, {markersetId: markersetId});
    }

    public duplicateMarkerset(markersetRequest: DuplicateMarkersetRequest) {
        return super.post<SuccessResponse>(`/api/Markerset/DuplicateMarkerset`, markersetRequest);
    }

    public getDefaultMarkerSet() {
        return super.get<Markerset>(`/api/Markerset/GetDefaultMarkerSet`, );
    }

    public getFilteredMarkersets(searchTerm: string = null, searchColumn: string = "name", sortColumn: string = "name", sortAscending: boolean = true, page: number = 0, pageSize: number = 2147483647) {
        return super.get<ListData<Markerset>>(`/api/Markerset/GetFilteredMarkersets`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getMarkersetById(markersetId: string) {
        return super.get<Markerset>(`/api/Markerset/GetMarkersetById`, {markersetId: markersetId});
    }

    public listMarkersets(searchTerm: string = null, sortColumn: string = "name", sortAscending: boolean = true, page: number = 0, pageSize: number = 2147483647) {
        return super.get<ListData<Markerset>>(`/api/Markerset/ListMarkersets`, {searchTerm: searchTerm, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public saveMarkerset(markerset: Markerset) {
        return super.post<SuccessResponse>(`/api/Markerset/SaveMarkerset`, markerset);
    }
}